/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, useEffect } from 'react';
import { Nav, Button } from 'react-bootstrap';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import styled from 'styled-components';
import Classes from './index.module.css';
import LeadFormModal from '../LeadFormModal';
import { useLocation } from "react-router-dom";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
const NavWrapper = styled.div`

.navbar-dark .navbar-nav .nav-link{
    color: white;
    z-index: 1200;
    white-space:nowrap;
    text-decoration: none;
}
.navbar-expand-lg .navbar-nav .dropdown-menu{
    margin: 0px 0px 0 -30px !important;
}

._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
    font-weight: 600;
}
}
.dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color:transparent;
    border-left: 4px solid #083F88;
    border-right: 4px solid #083F88;
    transition: all 0.1s linear;
    border-radius:2px;
}
.dropdown-item{
    border-bottom:2px solid transparent;
}
.dropdown-item:focus, .dropdown-item:hover{
    background-color:transparent;
}
 .dropdown-item:hover{
    border-bottom:2px solid  #083F88 !important;
    text-decoration: none;
}

@media(max-width:767px){
    .dropdown-item{
        border-bottom:0px transparent !important;
    }
    .dropdown-item:hover{
        border-bottom: 0px transparent !important;

    }
    .dropdown-menu{
      padding-left: 10px!important;
  }
}

#dropdown-item-button::after{
    content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA8ElEQVQ4jWNgGAUowHLOVSHjmc+4cMkbz3zGZTnnqhCyGBOMYTD/vsDvP2w7mf5/26E99SoPNs2M/79s+vWHbZ/xzJsiGAaw/PpbycDAYPKf4b8tFzPbRmSXGM98xsX0/+tmBgZGZ0YGBn1GBuZSuD4Y4z/DhxoGBj5VRgbGwP8MDE5Ql3hxsAj+Y/z/ZdN/BkYniErGrR9+/q+D6WNEdeYZVob/fCsZGRgDoZL7IIYzOEHo/+sZGD+Fn003+Y3VAGyGIADj1g+//gffyVP9iSKKbgB2Q7BrxmkAqiFMbLg0EwTGM8+wGs88w0qyxqEFAFtSY2S3+RTSAAAAAElFTkSuQmCC");
    vertical-align: -0.09em ;
    border:none;
    margin-top:5px;
}
.show>.btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    border-color:white;
}
.btn-primary:focus {

    border-color: white;
}
.btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
    background: #fff;
    color: #0481b5;
    border:1px solid #fff;
    box-shadow:none;
}
.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus{
    background: #fff;
    color: #0481b5;
    border:1px solid #fff;
    box-shadow:none;
}

.channelsNav{
    .dropdown-submenu-container a.dropdown-submenu::after {
        position: absolute;
        right: 0;
        top: 0;
    }
.dropdown-menu{
    .dropdown-toggle::after {
        content: ">";
        vertical-align: middle;
        border: none;
        margin-top: 4px;
        font-weight: 600;
        color: #dddd;
        transform: rotate(0) !important;
    }
    padding-right:15px !important;
}
}
@media(min-width:1067px) and (max-width:1201px){
    .navbar-dark .navbar-nav .nav-link{
        font-size: 14px !important;
        font-weight:600;
    }
    }

    @media(min-width:992px) and (max-width:1067px){
        .navbar-dark .navbar-nav .nav-link{
            font-size: 13px !important;
            font-weight: 500;
            padding: 10px 5px;
        }
        .eEKJvu ._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
            font-weight: 600;
            font-size: 14px;
        }
        }

`;


const Navbar1 = () => {
  const location = useLocation();
  const [navbarBackground, setNavbarBackground] = useState("transparent");
  const [modalVisible, setModalVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isCollapsing, setIsCollapsing] = useState(false);


  const [show, setShow] = useState(false);
  const [showLeadForm, setShowLeadForm] = useState(false);

  const handleShowLeadFormModal = () => setShowLeadForm(true);
  const handleCloseLeadFormModal = () => setShowLeadForm(false);

  const showDropdown = e => {
    setShow(!show);
  };
  const hideDropdown = e => {
    setShow(false);
  };
  const [show1, setShow1] = useState(false);
  const showDropdown1 = e => {
    setShow1(!show1);
  };
  const hideDropdown1 = e => {
    setShow1(false);
  };
  const [show2, setShow2] = useState(false);
  const showDropdown2 = e => {
    setShow2(!show2);
  };
  const hideDropdown2 = e => {
    setShow2(false);
  };

  const listenToScroll = () => {
    const scrollPosition = window.pageYOffset;
    const isTop = scrollPosition === 0;
    const shouldShowBackground = (!isTop || location.pathname !== "/" || modalVisible) &&
                                 (!isTop || location.pathname !== "/apply" || modalVisible);
  
    if (shouldShowBackground) {
      setNavbarBackground("#0B1E5F");
    } else {
      setNavbarBackground("transparent");
    }
  
    // Collapse menu when scrolling
    setExpanded(false);
  };
  
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => {
      window.removeEventListener("scroll", listenToScroll);
    };
  }, [modalVisible]);
  const handleModalToggle = () => {
    setModalVisible(!modalVisible);
    setNavbarBackground("#0B1E5F");
  };
  useEffect(() => {
    if (!expanded) {
      setIsCollapsing(true);
      // Wait just long enough to allow re-render before Bootstrap finishes collapse
      const timer = setTimeout(() => {
        setIsCollapsing(false);
      }, 50); // shorter than the transition to hide instantly
  
      return () => clearTimeout(timer);
    }
  }, [expanded]);
 

  return (
    <div>
      <NavWrapper>
      <Navbar
  style={{ backgroundColor: navbarBackground }}
  collapseOnSelect
  expand="lg"
  expanded={expanded}
  onToggle={(nextExpanded) => {
    setExpanded(nextExpanded);
    setModalVisible(nextExpanded); // Preserve your modal logic
    if (nextExpanded) {
      setNavbarBackground("#0B1E5F");
    }
  }}
  fixed="top"
  variant="dark"
  className={Classes.homepageNav}
>

          <Navbar.Brand className='d-flex'>

            <a
              href={process.env.REACT_APP_LINK_SWMCLOGO}>
              <img
                src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-White.webp"
                className={Classes.main_logo}
                alt="swmc-logo"
              /></a>

          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

              
          <Navbar.Collapse id="responsive-navbar-nav">
          
            <Nav className="mr-auto" style={{ margin: 'auto' }} />
            <Nav className={Classes.nav_temp}>
              <NavDropdown
                title="About"
                id="collasible-nav-dropdown"
                className={Classes.dropdown}
                show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}
              >
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_OURHISTORY}
                  to="/our-history"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  rel="noopener"
                  target="_blank"
                >
                  Our History
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_SUCCESSSTORIES}
                  to="/why-sunwest"
                  exact
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  target="_blank"
                >
                  Success Stories
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_CAREERS}
                  rel="noopener"
                  target="_blank"
                  to="/careers"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Careers
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_CONTACTUS}
                  rel="noopener"
                  target="_blank"
                  to="/contact-us"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="Loan Tools"
                id="collasible-nav-dropdown"
                show={show1}
                onMouseEnter={showDropdown1}
                onMouseLeave={hideDropdown1}
              >
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_CALCULATORS}
                  rel="noopener"
                  target="_blank"
                  to="/loan-calculators-mortgage-calculators"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Calculators
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_LOANPRODUCTS}
                  to="/loan-programs"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  rel="noopener"
                  target="_blank"
                >
                  Loan Products
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://www.swmc.com/blog/"
                  target="_blank"
                  rel="noopener"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  className={Classes.external}

                >
                  Blog
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://sunwestmortgage.myloaninfo.com/loanmanager/glossary/"
                  rel="noopener"
                  target="_blank"
                  className={Classes.external}
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Glossary
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_FAQ}
                  rel="noopener"
                  target="_blank"
                  to="/faq"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  FAQ
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_THEPROCESSOR}
                  rel="noopener"
                  target="_blank"
                  to="/theprocessor"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  The Processor
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_TURNTIMECOMMITMENT}
                  to="/turn-time-commitment"
                  rel="noopener"
                  target="_blank"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Turn Time Commitment
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://www.angelai.ai"
                  target="_blank"
                  rel="noopener"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  className={Classes.external}
                >
                  Angel Ai
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_PRICINGENGINE}
                  to="/priceengine"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown1(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                  rel="noopener"
                  target="_blank"
                >
                  Pricing Engine
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link
                href={process.env.REACT_APP_LINK_WHOLESALE}
                to="/wholesale-lending"
                rel="noopener"
                onClick={() => setExpanded(false)}
                target="_blank">
                Wholesale
              </Nav.Link>
              <Nav.Link
                href={process.env.REACT_APP_LINK_CORRESPONDENT}
                to="/correspondent-lending"
                rel="noopener"
                onClick={() => setExpanded(false)}
                target="_blank">
                Correspondent
              </Nav.Link>

              <NavDropdown
                title="Client Login"
                id="collasible-nav-dropdown"
                show={show2}
                onMouseEnter={showDropdown2}
                onMouseLeave={hideDropdown2}
              >
                <NavDropdown.Item
                  href="https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusLogin.jsf?loginByUsingView=CMOL"
                  target="_blank"
                  rel="noopener"
                  className={Classes.external}
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown2(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Check My Loan Progress
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://sunwestmortgage.myloaninfo.com/loanmanager/login/"
                  target="_blank"
                  rel="noopener"
                  className={Classes.external}
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown2(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Make a Payment
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_SERVICINGPORTAL}
                  rel="noopener"
                  target="_blank"
                  to="/loss-mitigation"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown2(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Servicing Portal
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_PROPERTYINSURANCE}
                  rel="noopener"
                  target="_blank"
                  to="/property-insurance"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown2(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  Property Insurance
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={process.env.REACT_APP_LINK_REVERSESOFTLOGIN}
                  rel="noopener"
                  target="_blank"
                  to="/sunsoft-login"
                  onClick={() => {
                    setExpanded(false);
                    hideDropdown2(); // or hideDropdown1/hideDropdown2 as needed
                  }}
                >
                  ReverseSoft Login
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                href={process.env.REACT_APP_LINK_PARTNERLOGIN}
                to="/login"
                rel="noopener"
                onClick={() => setExpanded(false)}
                target="_blank">
                Partner Login
              </Nav.Link>
              {!isCollapsing && (
  <div className={Classes.userwayMobile}>
    <UserWayAccessibilityMenu color="white" width={40} height={40} />
  </div>
)}

              {location.pathname === '/loan-officer-search' ||
                location.pathname === '/swmc-branch' ? (
                <Button
                  className={Classes.homepageButtonApply}
                  disabled
                  variant="primary"
                  size="md"
                  onClick={handleShowLeadFormModal}
                >
                  Apply Now
                </Button>
              ) : (
                <Button
                  className={Classes.homepageButtonApply}
                  variant="primary"
                  size="md"
                  onClick={handleShowLeadFormModal}
                  type="submit"
                >
                  Apply Now
                </Button>
              )}
             
            </Nav>
            <div className={Classes.userwayDesktop}>
           <UserWayAccessibilityMenu color="white" width={40} height={40} />
         </div>
            
          </Navbar.Collapse>
          
        </Navbar>
        
      </NavWrapper>
      <LeadFormModal
        loanOfficerId=""
        branchCode="058"
        leadSrc="NET001"
        loanPurpKeyword=""
        formHeading="Apply Now"
        showLeadFormModal={showLeadForm}
        onHide={handleCloseLeadFormModal}
      />
    </div>
  );
};

export default Navbar1;
